export const fetchExchangeRate = async () => {
  try {
    const response = await fetch(
      "https://api.exchangerate-api.com/v4/latest/JPY"
    );
    const data = await response.json();
    return data.rates.THB;
  } catch (error) {
    return 0.2;
  }
};
